import React, {Component} from 'react';
import {connect} from 'react-redux';
import agent from '../../agent';
import PostPreview from "../Post/PostPreview";
import {getLabel} from "../../language";
import {loadCommentsList} from "../../actions/commentsList";
import {Link} from "react-router-dom";
import PostAvatar from "../Post/PostAvatar";
import InfiniteScroll from "react-infinite-scroller";
import Loader from "../Loader";
import {TOPIC_STANCE_PAGE_UNLOADED, TOPIC_STANCE_PAGE_LOAD_MORE} from "../../constants/actionTypes";
import moment from "moment";
import {Helmet} from "react-helmet";


const mapStateToProps = state => ({
    ...state.postList,
    currentUser: state.common.currentUser,
    mention: state.mention,
    commentsList: state.commentsList.list,
    anonymous: state.user.anonymousMode,
    page: state.page,
    listTopicStances:state.topicPageStanceList.topicStances,
    hasMore:state.topicPageStanceList.hasMore
});

const mapDispatchToProps = dispatch => ({
    loadCommentsList: dispatch(loadCommentsList),
    onLoadMore: (payload) => dispatch({ type: TOPIC_STANCE_PAGE_LOAD_MORE, payload }),
    onUnload: () => dispatch({ type: TOPIC_STANCE_PAGE_UNLOADED }),
});

class TopicDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            dropDown: false,
            commentShow: false,
            isTopicStances:false,
        }
    }

    componentDidMount = async () => {
       await agent.Pollies.getPostByTopicOrLocation(this.props.topic.topic, this.props.topic.typePage).then(resp => {
            if (resp.length > 0 && resp[0].id) {
                agent.Pollies.getPostByTagId(resp[0].id).then(res => {
                    this.setState({
                        posts: res
                    });
                    if (res?.length > 0) {
                        const postsIds = this.getPostsIds(res);
                        if (postsIds?.length) {
                            this.props.loadCommentsList(postsIds.toString());
                        }
                    }
                })
            }
        })
        if(this.props?.commentId){
            const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
            if (elements){
                elements.scrollIntoView({ behavior: "smooth" })
            }
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props?.commentId){
            const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
            if (elements){
                elements.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    componentWillUnmount() {
        // this.props.onUnload();
    }

    getPostsIds = (res, posts) => {
        let postsList = posts ? posts : res;
        if (postsList?.length > 0) {
            return postsList.map(item => {
                return item.id
            })
        }
    };

    dropDownClick = () => {
        this.setState({
            dropDown: !this.state.dropDown
        })
    };

    handleTopicStance = () => {
        if(this.props.currentUser){
            this.props.history.push(`/topicstances/new${this.props.match.url}`,{topicId:this.props.topic.id})
        }else{
            this.props.history.push(`/login`)
        }
    }

    loadMore = async (page) => {
        await agent.topicStance.getByTopicId(this.props.topic.id, page-1).then(res =>{
            this.props.onLoadMore(res);
        }).catch(error => {
            console.log("error--->",error)
        })
    }

    handleTruncate = () => {
        this.setState({
            truncate:!this.state.truncate
        })
    }

    parseBody = body => {
        if(body !== undefined){
            let content = body;
            content = content?.replace(/\n/g, "<br/>");
            content = content?.replace(/  /g, "&nbsp;&nbsp;");
            content = content?.replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g, "<a href='$&' target='_blank'>$& </a>")

            return {__html: content};
        }else{
            return { __html: body };
        }

    };

  componentWillReceiveProps(nextProps) {
    const { topic } = nextProps
    const staticDescriptionElement = document.getElementById('main-description');
    if (staticDescriptionElement) {
      if(topic?.description_short) {
        staticDescriptionElement.remove();
      }
    }
  }

  componentWillUnmount() {
    const newStaticDescriptionElement = document.createElement('meta');
    newStaticDescriptionElement.id = 'main-description';
    newStaticDescriptionElement.name = 'description';
    newStaticDescriptionElement.content = 'A new social platform dedicated to politics. We\'re taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We\'re just getting started so this is just the beginning.';
    document.head.appendChild(newStaticDescriptionElement);
  }

    render() {
        const {posts } = this.state;
        const { listTopicStances, hasMore } = this.props;
        return (
          <>
            <Helmet>
              <link rel="canonical" href={`${new URL(document.URL).origin}/${this.props?.topic?.urlslug}`}/>
              <title>{this.props?.topic?.description_short || ''}</title>
              <meta name="description" content={(this.props?.topic?.description_long || '').slice(0,150)}/>
            </Helmet>
            <div className="container">
                {(this.props?.topic && (this.props?.topic?.description_short || this.props?.topic?.description_long)) &&
                    <div className="leftcontent">
                        <div className={`politiqbox${this.props.anonymous ? "-dark" : ""} topic-header`}>
                            <div>
                            <h1 className={`${this.props.anonymous ? "cw" : ""}`}>{this.props.topic.description_short || ''}</h1>
                            <div className={`${this.props.anonymous ? "cw" : ""}`} dangerouslySetInnerHTML={this.parseBody(this.props.topic.description_long || '')}/>
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                <div className="col-md-9 col-sm-9 col-xs-9">
                {
                    posts && posts.length > 0 ? posts.map((item, index) => {
                            return (
                                <PostPreview
                                    commentsList={this.props.commentsList}
                                    dropDownClick={this.dropDownClick}
                                    commentShow={this.state.commentShow}
                                    dropDown={this.state.dropDown}
                                    mention={this.props.mention}
                                    post={item}
                                    index={index}
                                    key={item.id}
                                    tags={item.tags}
                                    {...this.props}
                                />
                            );
                        })
                        : <div className={`${this.props.anonymous ? "cw" : ""} note-nothing-post`}>{getLabel(294)}</div>
                }
            </div>
                <div className="col-md-3 col-sm-3 col-xs-3">
                    <div className={`rightmenu${this.props.anonymous ? "-dark" : ""}`}>
                        <div className="content-right" id="content-right">
                            <div className="right-section">
                                <h4 className={`${this.props.anonymous ? " sidebar-color" : ""}`}>{`${getLabel(453)} ${this.props?.topic?.topic}`}</h4>
                                <div className="d-flex justify-content-center mb-2">
                                    <button className={`btn btn-border-stance btn-image`} onClick={() => this.handleTopicStance()}>
                                        {getLabel(452)}
                                    </button>
                                </div>
                                <ul>
                                    <InfiniteScroll
                                        pageStart={0}
                                        loadMore={this.loadMore}
                                        hasMore={hasMore}
                                        loader={<Loader/>
                                        }
                                    >
                                    {
                                        listTopicStances?.length > 0 ? listTopicStances.map((item) => {
                                            return (
                                                <li key={item.id}>
                                                    <a href="#" className="politician">
                                                        <div className="authorimage m-0 d-flex"><a className="politician">
                                                            <PostAvatar userName={item.author.userName} isAnonymous={item.anonymous}/>
                                                            <span
                                                                className={`${parseInt(item.author.gender) === 1 && "female "}${parseInt(item.author.gender) === 2 && "male"}`}/>
                                                        </a>

                                                        <span className="poli-info">
                                                                <Link className="link-to-post"
                                                                      to={'topicstance/' + item.slug}>
                                                                <div className="articletitle">
                                                                    {/*<div className={`m-b-5 ${this.props.anonymousMode ? "post-title-dark" : ""}`}>*/}
                                                                    {/*    {item.slug}*/}
                                                                    {/*</div>*/}
                                                                    {
                                                                        item.anonymous ?
                                                                            <div className="author">{getLabel(315)}</div> :
                                                                            <div className="author">{getLabel(170)} {item.author.displayName}</div>

                                                                    }
                                                                </div>
                                                            </Link>
                                                        {<span className={`occupation ${this.props.anonymous ? "cw" : ""}`}>{item.body.length > 150 ?
                                                            `${item.body.substring(0, 150)}...` : item.body
                                                        }{item.body.length > 150 ? <Link to={'topicstance/' + item.slug} className="link-to-post" >{getLabel(457)}</Link> : ""}</span>}

                                                    </span>
                                                        </div>
                                                    </a>
                                                </li>
                                            )
                                        }) : getLabel(442)
                                    }
                                    </InfiniteScroll>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicDetails);
